module.exports = __webpack_public_path__ + "img/phone.95386151.svg";